import { render } from "./PlusExamView.vue?vue&type=template&id=529d9be0&scoped=true"
import script from "./PlusExamView.vue?vue&type=script&lang=js"
export * from "./PlusExamView.vue?vue&type=script&lang=js"

import "./PlusExamView.vue?vue&type=style&index=0&id=529d9be0&scoped=true&lang=css"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-529d9be0"]])

export default __exports__